import {
  ButtonSecondary,
  ButtonSize,
  Currency,
  Filters,
  formatBalance,
  formatDate,
  IconDownload,
  SelectItemProps,
} from '@ui/src';
import { StatementListItem } from '../types';

import cn from '../styles.module.css';

const formatStatementsList = (
  list: StatementListItem[],
  filters: Filters,
  onDownloadStatement: (
    id: string,
    accountId: string,
    organizationId: string,
  ) => void,
  currencies?: SelectItemProps[],
  currenciesList?: Currency[],
  downloadIsLoading?: boolean,
  downloadedId?: string,
  selectedAccount?: string,
  exportAllowed?: boolean,
): StatementListItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let balance = '—';

    let currentGLAccount: any;

    if (
      selectedAccount &&
      result.generalLedgerTransaction &&
      result.generalLedgerTransaction.creditAccount.fullNumber ===
        selectedAccount
    ) {
      currentGLAccount = result.generalLedgerTransaction.creditAccount;
    } else if (
      selectedAccount &&
      result.generalLedgerTransaction &&
      result.generalLedgerTransaction.debitAccount.fullNumber ===
        selectedAccount
    ) {
      currentGLAccount = result.generalLedgerTransaction.debitAccount;
    }

    const currentCurrency = currenciesList?.find(
      (currency) => currency.id === result.currencyId,
    );

    if (filters.currencyId) {
      balance =
        typeof result?.balance === 'number'
          ? formatBalance(result?.balance, currentCurrency)
          : '-';

      if (filters.currencyId.value.length > 1) {
        balance = '—';
      }
    }

    const render: Record<string, any> = {
      transferDate: <div>{formatDate(result.transferDate || '', true)}</div>,
      counterpartyAccountDescription: (
        <div>
          {result.counterpartyAccountDescription
            ? result.counterpartyAccountDescription
            : '-'}
        </div>
      ),
      counterpartyAccountNumber: (
        <div>{result.counterpartyAccountNumber || '-'}</div>
      ),
      debitSum: (
        <div>
          {result.debitSum
            ? formatBalance(Number(result.debitSum), currentCurrency)
            : '0.00'}
        </div>
      ),
      creditSum: (
        <div>
          {result.creditSum
            ? formatBalance(Number(result.creditSum), currentCurrency)
            : '0.00'}
        </div>
      ),
      currencyId: (
        <div>
          {
            currencies?.find((currency) => currency.value === result.currencyId)
              ?.suffix
          }
        </div>
      ),
      balance: (
        <div className={cn.balance}>
          <span>{balance}</span>
          {currentGLAccount && exportAllowed && (
            <ButtonSecondary
              size={ButtonSize.SMALL}
              className={`button-white ${cn.downloadPdfButton}`}
              text={
                downloadIsLoading && downloadedId === result.id
                  ? 'Loading...'
                  : 'PDF'
              }
              icon={<IconDownload />}
              disabled={Boolean(
                downloadIsLoading && downloadedId === result.id,
              )}
              onClick={() =>
                onDownloadStatement(
                  result.id,
                  currentGLAccount.id,
                  currentGLAccount.organizationId,
                )
              }
            />
          )}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatStatementsList;
